import classNames from 'classnames';
import React, { Component, ReactNode } from 'react';

import './ImageBackgroundSlider.css';

export type ImageBackgroundSliderImage = { image: any, legend?: string } | string

interface Props {
    images: Array<ImageBackgroundSliderImage>

    animated?: boolean
    slider_animation_speed?: number

    background_filter?: boolean
    background_filter_color?: string

    children?: ReactNode
}
interface State {
    selected_image: number

    slider_animation_speed: number
    slider_active: boolean
}

export class ImageBackgroundSlider extends Component<Props, State>{
    interval: any

    constructor(props: Props) {
        super(props);
        this.state = {
            selected_image: 0,

            slider_active: !!props.animated,
            slider_animation_speed: props.slider_animation_speed || 5000,
        }
    }


    componentDidMount() {
        this.interval = setInterval(this.animate, this.state.slider_animation_speed)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    animate = () => {
        if (this.state.slider_active) {
            this.next();
        }
    }
    stop_slider = () => {
        this.setState({ slider_active: false })
    }

    get_image = (image: ImageBackgroundSliderImage) => {
        if (typeof image === 'string') {
            return image;
        }
        else {
            return image.image
        }
    }



    render() {
        return (
            <div className="image-background-slider">
                {
                    this.props.background_filter &&
                    <div
                        className="image-background-slider-background"
                        style={{
                            background: this.props.background_filter_color
                        }}
                    />
                }
                <div
                    className="image-background-slider-images-container"
                >
                    <div
                        className="image-background-slider-images"
                        style={{
                            transform: `translateX(-${this.state.selected_image * 100}%)`
                        }}
                    >
                        {
                            this.props.images.map((image: ImageBackgroundSliderImage, index: number) => (
                                <div key={index}
                                    className="image-background-slider-image"
                                    style={{
                                        backgroundImage: `url('${this.get_image(image)}')`,
                                        left: `calc(${100 * index}%)`
                                    }}
                                />
                            ))
                        }
                    </div>
                </div>

                {
                    this.props.animated &&
                    <div
                        className={classNames({
                            "image-background-slider-active": true,
                        })}
                        onClick={() => { this.setState({ slider_active: !this.state.slider_active }) }}
                    >
                        {
                            this.state.slider_active ?
                                <i className="fas fa-pause" />
                                :
                                <i className="fas fa-play" />
                        }
                    </div>

                }

                <div
                    className={classNames({
                        "image-background-slider-navigate left": true,
                        // "disabled": this.state.selected_image === 0
                    })}
                    onClick={() => { this.stop_slider(); this.previous() }}
                >
                    <i className="fas fa-chevron-left" />
                </div>
                <div
                    className={classNames({
                        "image-background-slider-navigate right": true,
                        // "disabled": this.state.selected_image < this.props.images.length
                    })}
                    onClick={() => { this.stop_slider(); this.next() }}
                >
                    <i className="fas fa-chevron-right" />
                </div>


                <div className="image-background-slider-select">
                    {
                        this.props.images.map((image, index: number) => (
                            <div key={index}
                                className={classNames({
                                    "image-background-slider-select-option": true,
                                    "active": this.state.selected_image === index
                                })}
                                onClick={() => { this.setState({ slider_active: false, selected_image: index }) }} />
                        ))
                    }
                </div>
                <div className="image-background-slider-content">
                    {this.props.children}
                </div>
            </div>
        );
    }

    previous = () => {
        if (this.state.selected_image > 0) {
            this.setState({ selected_image: this.state.selected_image - 1 })
        }
        else {
            this.setState({ selected_image: this.props.images.length - 1 })
        }
    }
    next = () => {
        if (this.state.selected_image < this.props.images.length - 1) {
            this.setState({ selected_image: this.state.selected_image + 1 })
        }
        else {
            this.setState({ selected_image: 0, })
        }
    }

    toggle_slider = () => {
        let slider_active = !this.state.slider_active;
        this.setState({ slider_active })
    }

};
